export const getValueOrDash = (value: any, transform?: (v: any) => any) => {
    if (value === null || value === undefined || value === '') return '-';
    return transform ? transform(value) : value;
  };

export const getValueOrDefault = (value: any, defaultValue: any = '-', transform?: (v: any) => any) => {
    if (value === null || value === undefined || value === '') return defaultValue;
    return transform ? transform(value) : value;
  };

export const checkValue = (value: any) => {
  return value !== undefined && value !== null && value !== '' && value !== '0' && value !== 'undefined';
};

export const checkValueAndReturnDefault = (value: any, defaultValue: any ) => {
  if (value !== undefined && value !== null && value !== '' && value !== '0' && value !== 'undefined') return value;
  return defaultValue;
};